import React from "react";
import * as Icons from "lucide-react";
import { FEATURES } from "../mock/mock";

export default function Features() {
  return (
    <section id="features" className="relative py-24 px-6 bg-forge-off">
      <div className="max-w-6xl mx-auto text-center mb-14">
        <div className="text-[11px] tracking-[0.3em] uppercase text-forge-gold">What To Expect</div>
        <h2 className="font-serif text-4xl md:text-5xl text-forge-navy mt-2">Every detail considered</h2>
        <hr className="forge-divider" />
        <p className="text-forge-navy/70 max-w-2xl mx-auto">
          Everything you need for a comfortable Anglesey stay — whether you're here for work or play.
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {FEATURES.map((f) => {
          const Icon = Icons[f.icon] || Icons.Star;
          return (
            <div key={f.title} className="feature-card">
              <div className="w-12 h-12 mx-auto rounded-full bg-forge-cream flex items-center justify-center mb-4">
                <Icon size={22} className="text-forge-navy" strokeWidth={1.5} />
              </div>
              <div className="font-serif text-lg text-forge-navy">{f.title}</div>
              <p className="text-sm text-forge-navy/65 mt-2 leading-relaxed">{f.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
